export const MEMBER_DIRECT_ERRORS = {
    SAVE_CLIENT_STATE_FAILED: 'save_client_state_failed',
    SURVEY_LOAD_FAILED: 'survey_load_failed',
    IDV_QUESTIONS_EMPTY: 'idv_questions_empty'
};
